// Entry for the standalone home page (public/home/index.html).
// It has no React bundle, so pull in what the rest of the site gets from
// main.jsx: the self-hosted fonts (@fontsource, no Google Fonts), the shared
// frame styles and the frame behaviour.
import '@fontsource/open-sans/latin-300.css'
import '@fontsource/open-sans/latin-400.css'
import '@fontsource/open-sans/latin-500.css'
import '@fontsource/open-sans/latin-600.css'
import '@fontsource/open-sans/latin-700.css'
import '@fontsource/open-sans/latin-ext-400.css'
import '@fontsource/open-sans/latin-ext-500.css'
import '@fontsource/open-sans/latin-ext-600.css'
import '@fontsource/open-sans/latin-ext-700.css'
import '@fontsource/poppins/latin-300.css'
import '@fontsource/poppins/latin-400.css'
import '@fontsource/poppins/latin-500.css'
import '@fontsource/poppins/latin-600.css'
import '@fontsource/poppins/latin-700.css'
import '@fontsource/poppins/latin-ext-500.css'
import '@fontsource/poppins/latin-ext-600.css'
import '@fontsource/poppins/latin-ext-700.css'
import './frame.css'
import { initFrame } from './frame.js'
import { initProductNav } from './frame-products.js'
import './home-lang.jsx'

const root = document.documentElement
root.classList.add('pbf-home')
try {
  const t = localStorage.getItem('pb-theme')
  if (t === 'light' || t === 'dark') root.setAttribute('data-theme', t)
} catch (_) {}

function syncToggle(btn) {
  const label = root.getAttribute('data-theme') === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'
  btn.setAttribute('aria-label', label)
  btn.setAttribute('title', label)
}
const btn = document.getElementById('themeToggle')
if (btn) {
  syncToggle(btn)
  btn.addEventListener('click', () => {
    const next = root.getAttribute('data-theme') === 'light' ? 'dark' : 'light'
    root.setAttribute('data-theme', next)
    try { localStorage.setItem('pb-theme', next) } catch (_) {}
    syncToggle(btn)
  })
}
initFrame()
initProductNav()
